import SignatureCanvas from './SignatureCanvas'

export * from './SignatureCanvas'
export default SignatureCanvas
